import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useNavigate } from "react-router-dom"; // 引入 useNavigate
import Header from "./Header"; // 引入 Header 组件
import Footer from "./Footer";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import MatterhornSwitzerland from "./asset/MatterhornSwitzerland.jpg";
import coldwalletproduct from "./asset/coldWallet1.png";
import img2 from "./asset/Mainattractionimage.webp";
import demoVideo from "./asset/LIKKIM.mp4";
import demoVideo2 from "./asset/LIKKIM2.mp4";
import demoVideo3 from "./asset/LIKKIMvideo.webm";
import demoVideo4 from "./asset/LIKKIM4.mp4";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaPlus,
  FaTwitter,
  FaTelegram,
  FaDiscord,
  FaReddit,
  FaInstagram,
  FaFacebook,
  FaLinkedin,
  FaArrowRight,
  FaYoutube,
} from "react-icons/fa";
import Modal from "react-modal";
function Likkim({ addToCart }) {
  const { t } = useTranslation();
  const productRef = useRef(null);
  const featureRef = useRef(null);
  const aboutUsRef = useRef(null);
  const faqRef = useRef(null);
  const backgroundRef = useRef(null);
  const technicalHighlightsRef = useRef(null);
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const navigate = useNavigate();
  const [variantAvailable, setVariantAvailable] = useState(false);
  const [variantId, setVariantId] = useState(null);
  const [product, setProduct] = useState(null);
  const [selectedColor, setSelectedColor] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const [faqStates, setFaqStates] = useState({
    faq1: false,
    faq2: false,
    faq3: false,
    faq4: false,
    faq5: false,
  });
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const toggleFAQ = (faqKey) => {
    setFaqStates((prevStates) => ({
      ...prevStates,
      [faqKey]: !prevStates[faqKey],
    }));
  };

  const handleColorChange = (color) => {
    if (!product || !product.variants) {
      console.error("Product data not loaded.");
      return;
    }

    setSelectedColor(color);
    console.log("Selected Color:", color);

    // 查找选中颜色的变体
    const selectedVariant = product.variants.find((variant) => {
      return variant.options && variant.options.includes(color);
    });

    if (selectedVariant) {
      setVariantId(selectedVariant.id);
      setVariantAvailable(selectedVariant.available);
      console.log(
        `Selected Variant: ${color}, Price: ${selectedVariant.price} CHF`
      );
    } else {
      console.error("No matching variant found for the selected color.");
    }
  };
  const [colorOptions, setColorOptions] = useState([]);
  const colorMapping = {
    Black: "#000000",
    "Champagne Gold": "#CCB68C",
    Silver: "#c0c0c0",
  };
  // 创建一个 scrollToRef 函数
  const scrollToRef = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  // 点击按钮跳转到 /product 页面
  const handleGoToProduct = () => {
    navigate("/buy-likkim");
  };

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.to(backgroundRef.current, {
      backgroundSize: "auto 110%", // 动画结束状态
      duration: 4, // 动画时长设置为 4 秒
      repeat: 0,
      ease: "power2.inOut",
    });

    // 确保产品图片始终居中
    gsap.to(productRef.current, {
      scale: 1.1, // 缩放到 110%
      duration: 4, // 动画时长设置为 4 秒
      repeat: 0,
      ease: "power2.inOut",
      onStart: () => {
        // 动画开始时确保产品图片居中
        productRef.current.style.transform = "translate(-50%, -50%)";
      },
    });
    // 设置缩放动画，起始值为0.8，滚动时到达1
    gsap.fromTo(
      ".scale-on-scroll",
      {
        scale: 0.8, // 初始值
      },
      {
        scale: 1, // 目标值
        scrollTrigger: {
          trigger: ".scale-on-scroll", // 目标元素
          start: "top bottom", // 当元素的顶部到达视口底部时，开始动画
          end: "top 30%", // 当元素的顶部到达视口上方25%时，结束动画
          scrub: true, // 平滑同步动画
          //   markers: true, // 可选：显示调试标记
        },
      }
    );
    gsap.fromTo(
      technicalHighlightsRef.current,
      {
        scale: 0.8, // 初始缩放
      },
      {
        scale: 1, // 最终缩放
        scrollTrigger: {
          trigger: technicalHighlightsRef.current, // 触发器
          start: "top bottom", // 动画开始的位置
          end: "top 30%", // 动画结束的位置
          scrub: true, // 平滑同步动画
        },
      }
    );

    // 使用GSAP设置动画：从居中到左对齐
    gsap.fromTo(
      imageRef.current,
      { x: "50%" }, // 初始位置：水平居中
      {
        x: "0%", // 最终位置：左对齐
        scrollTrigger: {
          trigger: imageRef.current, // 触发元素
          start: "top 25%", // 当元素的顶部到达视口底部时，开始动画
          end: "top 5%", // 当元素的顶部到达视口顶部时，结束动画
          scrub: true, // 平滑同步动画
        },
      }
    );

    // 文字动画：从居中到右对齐
    gsap.fromTo(
      textRef.current,
      { x: "50%" }, // 初始位置：水平居中
      {
        x: "100%", // 最终位置：右对齐
        scrollTrigger: {
          trigger: textRef.current, // 触发元素
          start: "top 25%", // 当元素的顶部到达视口25%时，开始动画
          end: "top 5%", // 当元素的顶部到达视口20%时，结束动画
          scrub: true, // 平滑同步动画
        },
      }
    );
  }, []);
  return (
    <div>
      <Header
        scrollToRef={scrollToRef}
        productRef={productRef}
        featureRef={featureRef}
        aboutUsRef={aboutUsRef}
        faqRef={faqRef}
      />
      {/*  下面的div需要配图 */}
      <div
        ref={backgroundRef}
        className="px-6 md:px-10 lg:px-20 py-10 mx-auto text-white h-[1040px] relative flex items-center justify-center"
        style={{
          backgroundImage: `url(${MatterhornSwitzerland})`,
          backgroundSize: "auto 100%", // 背景图初始尺寸
          backgroundPosition: "center", // 背景图居中
        }}
      >
        {/* 左侧文本和按钮部分 */}
        <div
          className="absolute left-0 bottom-0"
          style={{
            paddingLeft: "2%", // 文字和按钮的左边距，以百分比设置
            paddingBottom: "10%", // 减少底部边距，调整距离
          }}
        >
          <h1 className="text-5xl font-semibold mb-4">{t("LIKKIM")}</h1>
          <h2 className="text-3xl mb-6">{t("Security in your hands")}</h2>
          <div className="mt-8">
            <button
              onClick={() =>
                addToCart({
                  name: product?.title || "LIKKIM",
                  price: product?.variants?.[0]?.price?.amount || "0",
                  currency:
                    product?.variants?.[0]?.price?.currencyCode || "CHF",
                  variantId: product?.variants?.[0]?.id || null,
                })
              }
              className="px-8 py-3 w-full max-w-[300px] border border-white text-white rounded-[12px] hover:bg-white hover:text-black transition-all duration-300 backdrop-blur-sm bg-white/25 mb-4"
            >
              Add to cart
            </button>
            <button
              onClick={handleGoToProduct}
              className="px-8 py-3 w-full max-w-[300px] border border-white text-white rounded-[12px] hover:bg-white hover:text-black transition-all duration-300 backdrop-blur-sm bg-white/25"
            >
              Learn more
            </button>
          </div>
        </div>

        {/* 产品图片部分 */}
        <img
          ref={productRef}
          src={coldwalletproduct}
          alt="Cold Wallet"
          className="w-[600px] sm:w-[80%] z-20"
          style={{ maxHeight: "70%" }} // 限制图片的最大高度
        />
        {/* 右下角产品描述 */}
        <div
          //    className="absolute right-0 bottom-0 p-6 text-sm max-w-[400px] z-20"
          className="absolute right-0 bottom-0   text-sm max-w-[400px] z-20"
          style={{
            // backgroundColor: "rgba(255, 255, 255, 0.1)", // 背景色半透明
            borderRadius: "10px",
            marginRight: "2%", // 文字和按钮的左边距，以百分比设置
            marginBottom: "5%",
          }}
        >
          <h3 className="font-semibold text-xl mb-2">
            EAL6+ CHIP | TAMPER-PROOF | AIR-GAPPED
          </h3>
          <p className="mb-2 font-bold">
            Industry-leading EAL6+ secure chip. Hardware-grade protection for
            your keys.
          </p>
          <p className="mb-2 font-bold">
            Tamper detection and physical self-destruction for anti-theft
            assurance.
          </p>
          <p className="mb-2 font-bold">
            No Wi-Fi, no USB. 100% offline by design.
          </p>
          <p className="mb-2 font-bold">
            Open-source and fully auditable. Trust, verified.
          </p>
          <p className="mb-2 font-bold">
            Engineered for the most demanding security standards.
          </p>
        </div>
      </div>

      <div className="px-6 md:px-10 lg:px-20 py-10 mx-auto text-center text-white h-[1126px] flex flex-col justify-center items-center bg-neutral-800">
        <div className="w-full max-w-[1640px] flex flex-col items-start">
          <h1 className="text-3xl font-semibold mb-6">
            Built to Protect. Designed to Endure. 这是产品宣传视频
          </h1>
          {/* 这个div需要配图 */}
          <div
            className="w-full h-[750px] flex items-center justify-center bg-neutral-700 text-white rounded-[28px] px-6 text-center"
            style={{
              backgroundImage: `url(${img2})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="text-xl leading-relaxed space-y-6 max-w-[800px]">
              <p>
                Swiss-crafted and security-obsessed,
                <br />
                <strong>LIKKIM</strong> is the cold wallet for those who demand
                total control.
              </p>
              <p className="font-semibold text-2xl">
                Go offline. Stay untouchable.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="px-6 md:px-10 lg:px-20 py-10 mx-auto text-white h-[1126px] flex flex-col justify-center bg-neutral-900">
        {/* 标题部分 */}

        {/* 下面这个div需要配图 */}
        <div className="w-full max-w-[1640px] mx-auto flex-col flex items-start justify-start">
          {/* 左侧图片部分 */}
          <h2 className="text-3xl font-semibold mb-20 ">
            Smart Security. Maximum Utility. 这里是产品的基本信息展示 强调 eal6+
            ，防拆，完全离线
          </h2>
          <div className="w-full  flex  flex-row">
            <div className="w-1/2 flex justify-start items-center">
              <div className="relative w-full h-[750px] rounded-[28px] overflow-hidden bg-neutral-800">
                <video
                  className="w-full h-full object-cover"
                  src={demoVideo}
                  autoPlay
                  loop
                  muted
                  playsInline
                ></video>

                {/* 标签容器：用 margin 来控制与边缘的距离 */}
                <div className="absolute bottom-0 left-0 m-10 flex flex-wrap gap-2 text-sm font-medium">
                  <span className="inline-flex items-center px-3 h-8 bg-[#CCB68C] text-black rounded-[8px]">
                    🛡 EAL 6+
                  </span>
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    🖥 Air-gapped Signing
                  </span>
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    🔒 Fingerprint
                  </span>
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    🔗 Bluetooth
                  </span>
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    📱 Touchscreen
                  </span>
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    🔋 5h Battery Life
                  </span>
                  {/* ✅ 新增：续航标签 */}
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    💧 IP65 Water & Dust
                  </span>
                  {/* ✅ 新增：防水防尘标签 */}
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    🔑 Security Key
                  </span>
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    🔌 USB-C
                  </span>
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    💻 Full platform support
                  </span>
                  <span className="inline-flex items-center px-3 h-8 border rounded-[8px] text-white bg-black/30">
                    ₿ 5000+ coins supported
                  </span>
                </div>
              </div>
            </div>
            {/* 右侧文字部分 */}
            <div className="w-1/2 p-10 text-left flex flex-col justify-center text-lg leading-relaxed">
              <p className="mb-6">
                Unlock instantly with biometric fingerprint authentication.
              </p>
              <p className="mb-6">
                Manage 5000+ cryptocurrencies and NFTs across 30+ major
                blockchains — all in one place.
              </p>
              <p className="mb-6">
                Swap tokens directly inside the device. No cables, no apps, no
                exposure.
              </p>
              <p>
                Setup in under 60 seconds. Recover anytime using your encrypted
                NFC backup card.
              </p>
              <p className="mt-6">
                Lost your wallet? Instantly locate it via the last known
                Bluetooth connection.
              </p>

              {/* Color Options */}
              <div className="space-y-4 mt-8">
                <div className="flex gap-4 mt-4">
                  <button
                    className="w-8 h-8 rounded-full border-4 border-neutral-600"
                    style={{ backgroundColor: "#000000" }} // Black
                    aria-label="Black"
                  ></button>
                  <button
                    className="w-8 h-8 rounded-full border-4 border-neutral-600"
                    style={{ backgroundColor: "#CCB68C" }} // Champagne Gold
                    aria-label="Champagne Gold"
                  ></button>
                  <button
                    className="w-8 h-8 rounded-full border-4 border-neutral-600"
                    style={{ backgroundColor: "#c0c0c0" }} // Silver
                    aria-label="Silver"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 md:px-10 lg:px-20 py-10 mx-auto text-center text-white h-[2126px] flex flex-col justify-center items-center bg-neutral-800">
        <div className="w-full max-w-[1640px] flex flex-col items-start">
          <h1 className="text-3xl font-semibold mb-6">
            Technology that Defends You
            支持指纹解锁,支持5000+,与NFT展示,设备查找功能
          </h1>
          <div className="carousel-outer-container my-10">
            <div className="carousel-container">
              {Array.from({ length: 40 }, (_, i) => (
                <div key={i} className="carousel-item">
                  <img
                    src={`./Icon/Icon${(i % 20) + 1}.png`}
                    alt={`Icon ${(i % 20) + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>

          <div
            ref={technicalHighlightsRef}
            className="relative my-10 px-6 py-8 text-white rounded-[28px] w-full h-[750px] overflow-hidden flex items-center justify-center"
          >
            {/* 背景视频层 */}
            <video
              className="absolute top-0 left-0 w-full h-full object-cover z-0"
              src={demoVideo2}
              autoPlay
              loop
              muted
              playsInline
            />

            {/* 内容层 */}
            <div className="relative z-10 max-w-[800px] w-full">
              <ul className="space-y-4 text-left text-lg leading-relaxed list-none pl-0">
                <li>
                  <span className="font-semibold">
                    EAL6+ Military-Grade Secure Chip:
                  </span>
                  Industry-leading cryptographic protection.
                </li>
                <li>
                  <span className="font-semibold">
                    Self-destruct Tamper Protection:
                  </span>
                  Built-in defense against physical attacks.
                </li>
                <li>
                  <span className="font-semibold">100% Offline Operation:</span>
                  No Wi-Fi, no USB, no remote attack vectors.
                </li>
                <li>
                  <span className="font-semibold">Fingerprint Unlock:</span>
                  Fast, secure biometric authentication.
                </li>
                <li>
                  <span className="font-semibold">
                    Built-in Swap & NFT Display:
                  </span>
                  Support for 5000+ assets across 30+ chains.
                </li>
                <li>
                  <span className="font-semibold">
                    Encrypted NFC Recovery & Device Locator:
                  </span>
                  Restore your wallet, find your device.
                </li>
              </ul>
            </div>
          </div>

          <div className="w-full  flex  flex-row my-10">
            <div className="w-1/2 p-10 text-left flex flex-col justify-center text-lg leading-relaxed">
              <p className="mb-6">
                Lost your wallet? Locate it instantly via last known Bluetooth
                position.
              </p>
              <p className="mb-6">
                Paired with the LIKKIM mobile app for remote sync, security
                alerts, and firmware updates.
              </p>
            </div>
            <div className="w-1/2 flex justify-start items-center">
              <div className="relative w-full h-[750px] rounded-[28px] overflow-hidden bg-neutral-800">
                <video
                  className="w-full h-full object-cover"
                  src={demoVideo4}
                  autoPlay
                  loop
                  muted
                  playsInline
                ></video>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-6 md:px-10 lg:px-20 py-10 mx-auto text-center text-white h-[1126px] flex flex-col justify-center items-center bg-neutral-900">
        <div className="w-full max-w-[1640px]   items-center justify-start">
          <div className="relative   mx-auto text-center text-white h-[1126px] flex items-center justify-start bg-neutral-900">
            <div className="w-full max-w-[1640px] flex items-center justify-start">
              {/* 左侧图片部分 */}
              {/* 下面这个div需要配图 */}
              <div
                ref={imageRef}
                className="absolute top-0 z-10 w-1/2 h-full flex justify-center items-center"
              >
                <div className="px-4 py-2 bg-neutral-700 text-white rounded-[28px] w-full h-[750px] transition-colors flex justify-center items-center">
                  <video
                    src={demoVideo3}
                    className="w-full h-auto max-w-[350px] rounded-lg"
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                </div>
              </div>
              {/* 右侧文字部分 */}
              <div
                ref={textRef}
                className="absolute top-0 z-0 w-1/2 h-full flex flex-col justify-center px-10 text-left text-white"
              >
                <h2 className="text-3xl font-semibold mb-6">
                  Designed to Impress. Built to Last.
                  瑞士设计与高品质设计,国际设计大奖
                </h2>
                <ul className="text-lg space-y-4 list-disc pl-6">
                  <li>
                    Swiss-engineered with award-winning aesthetics (Red Dot & iF
                    Design).
                  </li>
                  <li>
                    High-resolution touchscreen for fluid, intuitive
                    interactions.
                  </li>
                  <li>
                    Built-in 5-hour battery ensures day-long performance
                    on-the-go.
                  </li>
                  <li>
                    IP65-rated water and dust resistance — rugged and ready for
                    any setting.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-6 md:px-10 lg:px-20 py-10 mx-auto text-white bg-neutral-800 text-center">
        <div className="w-full max-w-[800px] mx-auto flex flex-col justify-center items-center">
          <h2 className="text-3xl font-semibold mb-6">
            Peace of Mind Comes Standard
          </h2>
          <ul className="text-lg space-y-4 list-disc text-left pl-6">
            <li>1-Year Limited Warranty</li>
            <li>Professional support team (Email & Online)</li>
          </ul>
        </div>
      </div>
      <div className="bg-neutral-900 text-white py-16 px-8 w-full">
        <div className="max-w-[1440px] mx-auto px-6">
          <h2 className="text-3xl font-bold mb-8">{t("faq")}</h2>
          <div className="w-full flex items-center justify-center flex-col">
            <div className="flex flex-col w-[60vw] md:w-[90vw] sm:w-[90vw] max-w-[1280px] mb-[16px] h-auto bg-[#111] rounded-xl text-white px-[30px] py-[20px] flex items-center">
              <div
                className="flex w-full items-center cursor-pointer"
                onClick={() => toggleFAQ("faq1")}
              >
                <FaPlus
                  size="12px"
                  color="white"
                  className={`mr-[10px] ${
                    faqStates.faq1 ? "rotated-icon" : ""
                  }`}
                />
                {t("WhatIsColdWallet")}
              </div>

              <AnimatePresence>
                {faqStates.faq1 && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                    className="FAQAnswer"
                  >
                    {t("ColdWalletDescription")}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <div className="flex flex-col w-[60vw] md:w-[90vw] sm:w-[90vw] max-w-[1280px] mb-[16px] h-auto bg-[#111] rounded-xl text-white px-[30px] py-[20px] flex items-center">
              <div
                className="flex w-full items-center cursor-pointer"
                onClick={() => toggleFAQ("faq2")}
              >
                <FaPlus
                  size="12px"
                  color="white"
                  className={`mr-[10px] ${
                    faqStates.faq2 ? "rotated-icon" : ""
                  }`}
                />
                {t("HowToSetUpColdWallet")}
              </div>

              <AnimatePresence>
                {faqStates.faq2 && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                    className="FAQAnswer"
                  >
                    {t("ColdWalletSetupDescription")}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <div className="flex flex-col w-[60vw] md:w-[90vw] sm:w-[90vw] max-w-[1280px] mb-[16px] h-auto bg-[#111] rounded-xl text-white px-[30px] py-[20px] flex items-center">
              <div
                className="flex w-full items-center cursor-pointer"
                onClick={() => toggleFAQ("faq3")}
              >
                <FaPlus
                  size="12px"
                  color="white"
                  className={`mr-[10px] ${
                    faqStates.faq3 ? "rotated-icon" : ""
                  }`}
                />
                {t("CryptocurrenciesCompatibleWithColdWallet")}
              </div>

              <AnimatePresence>
                {faqStates.faq3 && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                    className="FAQAnswer"
                  >
                    {t("CryptocurrenciesCompatibilityDescription")}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <div className="flex flex-col w-[60vw] md:w-[90vw] sm:w-[90vw] max-w-[1280px] mb-[16px] h-auto bg-[#111] rounded-xl text-white px-[30px] py-[20px] flex items-center">
              <div
                className="flex w-full items-center cursor-pointer"
                onClick={() => toggleFAQ("faq4")}
              >
                <FaPlus
                  size="12px"
                  color="white"
                  className={`mr-[10px] ${
                    faqStates.faq4 ? "rotated-icon" : ""
                  }`}
                />
                {t("HowToSecureColdWallet")}
              </div>

              <AnimatePresence>
                {faqStates.faq4 && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                    className="FAQAnswer"
                  >
                    {t("ColdWalletSecurityDescription")}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <div className="flex flex-col w-[60vw] md:w-[90vw] sm:w-[90vw] max-w-[1280px] mb-[16px] h-auto bg-[#111] rounded-xl text-white px-[30px] py-[20px] flex items-center">
              <div
                className="flex w-full items-center cursor-pointer"
                onClick={() => toggleFAQ("faq5")}
              >
                <FaPlus
                  size="12px"
                  color="white"
                  className={`mr-[10px] ${
                    faqStates.faq5 ? "rotated-icon" : ""
                  }`}
                />
                {t("ColdWalletNotWorking")}
              </div>

              <AnimatePresence>
                {faqStates.faq5 && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                    className="FAQAnswer"
                  >
                    {t("ColdWalletErrorDescription")}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
      {/* Stay Connected and Newsletter Section */}
      <div className="bg-neutral-800 text-white py-16 px-8 w-full">
        <div className="max-w-[1440px] mx-auto px-6 flex flex-row sm:flex-col justify-between items-center">
          {/* Left Side - Stay Connected */}
          <div className="max-w-lg mb-8 md:mb-0">
            <h2 className="text-3xl font-bold mb-4">Stay in touch</h2>
            <p>Announcements can be found in our blog.</p>
            <p className="mt-2">
              Press contact:{" "}
              <a href="mailto:info@likkim.com" className="text-blue-400">
                info@likkim.com
              </a>
            </p>

            <div className="flex flex-wrap justify-start mt-4 gap-4">
              <a
                href="https://x.com/LIKKIMwallet"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter className="text-white bg-neutral-600 rounded-full p-3 w-12 h-12" />
              </a>
              <a
                href="https://t.me/+q9j351SAY8hlMDJl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTelegram className="text-white bg-neutral-600 rounded-full p-3 w-12 h-12" />
              </a>
              <a
                href="https://discord.gg/59hKBX2daq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaDiscord className="text-white bg-neutral-600 rounded-full p-3 w-12 h-12" />
              </a>
              <a
                href="https://www.reddit.com/user/Ok_Bass_6829/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaReddit className="text-white bg-neutral-600 rounded-full p-3 w-12 h-12" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="text-white bg-neutral-600 rounded-full p-3 w-12 h-12" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61570753106156"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook className="text-white bg-neutral-600 rounded-full p-3 w-12 h-12" />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="text-white bg-neutral-600 rounded-full p-3 w-12 h-12" />
              </a>
              <a
                href="https://www.youtube.com/@LukkeyAG"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube className="text-white bg-neutral-600 rounded-full p-3 w-12 h-12" />
              </a>
            </div>
          </div>

          {/* Right Side - Newsletter Subscription */}
          <div className="max-w-lg">
            <h2 className="text-3xl font-bold mb-4">
              Subscribe to our newsletter
            </h2>
            <p>
              New coins supported, blog updates, and exclusive offers directly
              in your inbox
            </p>
            <div className="mt-4 flex items-center">
              <input
                type="email"
                placeholder="Your email"
                className="p-4 rounded-full bg-neutral-900 text-white border border-neutral-600 outline-none flex-grow placeholder-neutral-500"
              />
              <button
                className="p-4 rounded-full bg-white text-black flex items-center justify-center gap-2 ml-4 min-w-[180px]"
                onClick={openModal} // 点击按钮时打开弹窗
              >
                <span>Subscribe to newsletter</span>
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
        {/* 弹窗 */}
        <Modal
          isOpen={isModalOpen} // 控制弹窗的显示
          onRequestClose={closeModal} // 点击外部关闭弹窗
          contentLabel="Email Confirmation"
          className="w-[80%] max-w-[600px] mx-auto p-6 bg-white rounded-lg"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
        >
          <h2 className="text-2xl font-semibold mb-4">Confirm your email</h2>
          <p className="mb-4">
            Please open the confirmation email sent to you and click the
            verification link. Please be sure to check your spam folder too.
          </p>
          <p className="mb-6">You will be able to unsubscribe at any time.</p>
          <button
            onClick={closeModal} // 关闭弹窗
            className="px-8 py-3 bg-neutral-800 text-white rounded-full mx-auto block w-full max-w-[400px]"
          >
            Close
          </button>
        </Modal>
      </div>
      <Footer
        productRef={productRef}
        featureRef={featureRef}
        aboutUsRef={aboutUsRef}
        faqRef={faqRef}
      />
    </div>
  );
}

export default Likkim;
